import { HiOutlineMail } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";

const data = [
  { id: 1, icon: <HiOutlineMail />, link: "mailto:eemmanueljoshua@gmail.com" },
  {
    id: 2,
    icon: <FaWhatsapp />,
    link: "https://api.whatsapp.com/send/?phone=%+91965278334",
  },
];

// alternatibve WhatsApp link: https://wa.me/yournumber

export default data;
